// Hero

var $ = require('jquery');
import { gsap } from "gsap";

$(window).on('load', function() {
    initHero();
    interiorHero();
})

$(window).on('resize', function() {
    calcHeroImageSize();
})
setTimeout(function() {
  $(window).trigger('resize');  
}, 100);

function initHero() {   
    if ( !$('.hero').length ) return;
    setInterval(function() {
        var heroImages = $(".hero__image");
        var activeHeroImage = $('.hero__image.active');
        var nextHeroImage = activeHeroImage.next().length ? activeHeroImage.next() : heroImages.eq(0);

        nextHeroImage.addClass('to-fade-in');
        activeHeroImage.addClass( 'to-fade-out' );

        setTimeout(function() {
            activeHeroImage.removeClass( 'active' );
            activeHeroImage.removeClass( 'to-fade-out' );
            nextHeroImage.removeClass('to-fade-in');
            nextHeroImage.addClass('active');
            activeHeroImage = nextHeroImage
        }, 750);
        
    }, 10000);
}

function calcHeroImageSize() {
    var heroImages = $('.hero').length ? $('.hero__images') : $('.hero__image-interior') ;

    var width = parseFloat(($(window).width() - $('.container').outerWidth()) / 2);
    var heroPosition = parseFloat($('.container').outerWidth() * .64);
    
    if ( $('.hero').length ) {

        heroImages.removeAttr('style');
                
        if ($(".site-header__menu .header__toggle:visible").length) {


            var heroHeight = $('.hero').height();
            var topHeight = $('.hero__content').height() + $('.site-header').height() - 6;
            heroImages.css('height', ( heroHeight - topHeight) ).css('width', ( heroHeight - topHeight) * 1.25 );

            /*
            .find('.hero__image').each(function() {
                //$(this).css('width', heroPosition + width );
                $(this).find('img').css('height', (275 - 25) );
            })
            */
        }
        
    } else if ( $('.hero__image-interior').length ) {
        heroPosition = parseFloat($('.container').outerWidth() * .5);
        $('.hero__image-interior').css('width', heroPosition + width );
        $('.hero__image-interior').find('img').css('height', $('.is-style-hero-interior').outerHeight());
    }

}

function interiorHero() {
    if ( $('.is-style-hero-interior').length ) {
        $('.is-style-hero-interior').find('.wp-block-cover__image-background').wrap('<div class="hero__image-interior">');
        $(".site-header").addClass("--has-internal-hero");
    }
}